import React from 'react';
import { string } from 'prop-types';

import SCSpinner from './styles';

Spinner.propTypes = {
  size: string,
  color: string,
};

Spinner.defaultProps = {
  size: '64px',
  color: null,
};

function Spinner({ size, color }) {
  return (
    <SCSpinner size={size} color={color}>
      <div />
      <div />
      <div />
      <div />
    </SCSpinner>
  );
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.js